import IAudienceSegmentCalculation from '@/models/interfaces/IAudienceSegmentCalculation';
import IAudienceSegmentQuestionResponse from '@/models/interfaces/IAudienceSegmentQuestionResponse';

class AudienceSegmentationService {
  private static serviceInstance: AudienceSegmentationService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  private calculate(responses: IAudienceSegmentQuestionResponse[]): IAudienceSegmentCalculation[] {
    if (!responses) {
      return [];
    }

    const results: IAudienceSegmentCalculation[] = [
      {
        id: 1,
        type: 'Sustainable Status-seeker',
        value: (responses[0].value * (2.874)) + (responses[1].value * (1.078)) + (responses[2].value * (2.601)) + (responses[3].value * (0.673)) + (-27.92)
      },
      {
        id: 2,
        type: 'Family first',
        value: (responses[0].value * (3.013)) + (responses[1].value * (2.051)) + (responses[2].value * (2.541)) + (responses[3].value * (1.673)) + (-39.367)
      },
      {
        id: 3,
        type: 'Affordable A-to-B',
        value: (responses[0].value * (1.332)) + (responses[1].value * (1.671)) + (responses[2].value * (2.46)) + (responses[3].value * (0.829)) + (-20.897)
      },
      {
        id: 4,
        type: 'Tech-adverse Traditionalists',
        value: (responses[0].value * (2.391)) + (responses[1].value * (1.278)) + (responses[2].value * (1.476)) + (responses[3].value * (1.198)) + (-19.597)
      },
      {
        id: 5,
        type: 'Modern Metropolitans',
        value: (responses[0].value * (2.499)) + (responses[1].value * (1.619)) + (responses[2].value * (2.121)) + (responses[3].value * (1.318)) + (-26.755)
      },
      {
        id: 6,
        type: 'Disengaged Deal-seekers',
        value: (responses[0].value * (1.945)) + (responses[1].value * (1.383)) + (responses[2].value * (2.083)) + (responses[3].value * (1.149)) + (-22.082)
      }
    ];

    return results;
  }

  public getAudienceSegment(responses: IAudienceSegmentQuestionResponse[]): IAudienceSegmentCalculation | null {
    const results = this.calculate(responses);

    if (!results) {
      return null;
    }

    const maxValue = results.reduce((prev, current) => ((prev.value > current.value) ? prev : current));

    if (!maxValue) {
      return null;
    }

    return maxValue;
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const audienceSegmentationService = AudienceSegmentationService.instance;
